import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\"><path d=\"M972.92032 449.536a51.2 51.2 0 0 0-51.2 51.2v132.608l-301.056-301.056a51.2 51.2 0 0 0-72.192 0L368.76032 512 87.67232 230.912A51.2 51.2 0 0 0 14.96832 303.616l317.44 317.44a51.2 51.2 0 0 0 72.192 0l179.712-179.712 264.704 264.704H716.92032a51.2 51.2 0 0 0 0 102.4h256a51.2 51.2 0 0 0 51.2-51.2v-256a51.2 51.2 0 0 0-51.2-51.712z\" fill=\"#2aa515\" p-id=\"2091\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol